import NewNavbar from "../../../../components/Landing/NewNavbar";
import SOPPageComponent from "../../../../components/sop/PageComponents/SOPPageComponent";
import MetaTags from "../../../../components/generic/MetaTags";
// import SOPHeader from "../../../../components/Onboarding/header";
import useVerifyUser from "../../../../utils/useVerifyUser";
// interface MyComponentProps {
//   color: string;
// }
const SOPGenerate = () => {
  useVerifyUser();
  return (
    <main className="bg-tootler-primary-50 font-Inter">
      <MetaTags PageName="Step-2 | New SOP | SOP Editor" />

      <NewNavbar color="tootler-primary-50" />
      {/* <SOPHeader step={2} /> */}
      <SOPPageComponent> </SOPPageComponent>
    </main>
  );
};

export default SOPGenerate;
